module.exports = __webpack_public_path__ + "img/info-icon.9b94daa9.svg";